import script from "./App.vue?vue&type=script&setup=true&allowJs=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&allowJs=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=69d0750a&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=69d0750a&lang=css"

import exportComponent from "D:\\Projects\\mgo1-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d0750a"]])

export default __exports__